import './process-shim';
import { provideZonelessChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Zoneless: rendering is scheduled by signal writes, template event
// listeners, and markForCheck — no zone.js macrotask patching.
bootstrapApplication(AppComponent, {...appConfig, providers: [provideZonelessChangeDetection(), ...appConfig.providers]}).catch((err) =>
  console.error('bootstrapApplication error', err),
);
